import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Formik, FormikProps } from 'formik';
import { UserInfo } from '@shared/interfaces/UserInfo';
import { FlagFiltersFields } from '../../interfaces/FlagFiltersFields';
import { SearchParamObject } from '@shared/interfaces/SearchParamObject';
import { DepartmentData } from '@shared/interfaces/DepartmentData';
import { FiltersForm } from '../FiltersForm/FiltersForm';
import { projectEndObject, statusObject, userStatusesObject } from '../../constants/constants';
import noop from 'lodash/noop';
import { BaseFiltersDrawer } from '@shared/components/BaseFiltersDrawer/BaseFiltersDrawer';

interface Props {
  tomData: UserInfo[];
  prData: UserInfo[];
  allDeparttmentsData: DepartmentData[];
  isLoading: boolean;
  initialValues: FlagFiltersFields;
  isFilterLoading: boolean;
}

export const AllFlagsFilters: React.FC<Props> = ({
  tomData,
  prData,
  allDeparttmentsData,
  isLoading,
  initialValues,
  isFilterLoading,
}) => {
  const formRef = useRef<FormikProps<FlagFiltersFields>>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const searchParamsObject = () => {
    const obj: SearchParamObject = {};
    for (const [key, value] of searchParams.entries()) {
      obj[key] = value;
    }
    return obj;
  };
  const filtersLength = Object.keys(searchParamsObject()).length;

  const handleResetFilters = () => {
    setSearchParams({});
    formRef.current?.setValues({
      severity: 'all',
      status: [statusObject.all.label],
      isNewHomeNeeded: false,
      isAnotherOfferInvolved: false,
      projectEnd: projectEndObject.anyTime.value,
      userStatuses: [userStatusesObject.all.label],
      involvedUsers: [],
      flagAuthors: [],
      flagManagers: [],
      assignedTomIds: [],
      assignedPrIds: [],
      legalLocations: [],
      assignedProjects: [],
      affectedProjects: [],
      reasonsSubReasons: [],
      resolvedDateFrom: null,
      resolvedDateTo: null,
      escalationDateFrom: null,
      escalationDateTo: null,
      isEscalatedByClient: false,
    });
  };

  return (
    <BaseFiltersDrawer
      isLoading={isLoading}
      filtersCount={filtersLength}
      onReset={handleResetFilters}
      renderDrawer={!isFilterLoading}
    >
      <Formik initialValues={initialValues} innerRef={formRef} onSubmit={noop} validateOnMount>
        {() => <FiltersForm allDeparttmentsData={allDeparttmentsData} tomData={tomData} prData={prData} />}
      </Formik>
    </BaseFiltersDrawer>
  );
};
